import { none } from "widgets-for-react";
import { fromNullable, valueOrExcept } from "../../Shared/utils/option";
import bkw from "./bkw";
import flevo from "./flevo";
import rdam from "./rdam";
import twente from "./twente";
import whiteLabel from "./whitelabel";
// Define LibraryIDs and guard clause
const libraryIDs = [
    'vbp',
    'bkw',
    'flevo',
    'rdam',
    'twente'
];
const isLibraryID = (id)=>libraryIDs.includes(id);
const libraryCustomizations = {
    bkw,
    flevo,
    rdam,
    twente,
    vbp: whiteLabel
};
// Set application wide Library at runtime
let _library = none();
export const setLibrary = (id)=>{
    if (!isLibraryID(id)) throw new TypeError(`Library ID must be one of: ${libraryIDs.join(', ')}`);
    _library = fromNullable(libraryCustomizations[id]);
};
// Get Library at runtime
export const library = ()=>valueOrExcept(_library, 'Library has not yet been set. Make sure to call library() within the context of the React Application component.');
